import { render, staticRenderFns } from "./crm-staff-create-new.vue?vue&type=template&id=d386bb30&"
import script from "./crm-staff-create-new.vue?vue&type=script&lang=js&"
export * from "./crm-staff-create-new.vue?vue&type=script&lang=js&"
import style0 from "./crm-staff-create-new.vue?vue&type=style&index=0&id=d386bb30&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports